import React from 'react';

const MobileBackIcon = () => {
    return (
        <svg
            width="22"
            height="25"
            viewBox="0 0 42 78"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M38.9909 3L3 39L39 75"
                stroke="#464B59"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default MobileBackIcon;
